module.exports = __webpack_public_path__ + "img/icon-profile.dcc9300a.png";